import leadStatusApi from '@src/features/leads/services/lead-status-api';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipLeadStatusValue = ({ id }: ChipValueRendererProps) => {
  const { data: status } = leadStatusApi.useFetchOne({ id });

  return <>{status?.name}</>;
};
